var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System/search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9469 13.7714L19.7551 18.5796C20.0816 18.902 20.0816 19.4327 19.7551 19.7551C19.4286 20.0816 18.902 20.0816 18.5755 19.7551L13.7673 14.951C12.3143 16.1429 10.4571 16.8571 8.42857 16.8571C3.77143 16.8571 0 13.0816 0 8.42857C0 3.77551 3.77143 0 8.42857 0C13.0816 0 16.8571 3.77551 16.8571 8.42857C16.8571 10.4571 16.1388 12.3184 14.9469 13.7714ZM1.67347 8.42857C1.67347 12.151 4.70204 15.1796 8.42857 15.1796C12.151 15.1796 15.1837 12.151 15.1837 8.42857C15.1837 4.70612 12.151 1.67347 8.42857 1.67347C4.70204 1.67347 1.67347 4.70612 1.67347 8.42857Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.070aec49cc49c3fa025a071eaf5d1660.svg";
export { ForwardRef as ReactComponent };